export const multiAppHomeProps = {
    pageDescriptions: [{
            description_title: 'Discover Property on your terms',
            description: 'Whether you require a fully fitted space for a certain timeslots, a working space for a few months or a property you can call your own on a lease, GetSpaces is here to make that happen. Find your dream space in the right way with us.',
        },
        {
            description_title: 'Rent flexible spaces by the hour, day or month',
            description: 'Looking for a studio to for fitness and dance? Need a beautiful space to run classes or workshops? Looking for a venue to hold a corporate or a private event? Our flexible space marketplace has got you covered.',
        },
        {
            description_title: 'Save more with credits',
            description: 'Purchase our credits package and get more bang for your buck! Get access to our corporate concierge service and let us help you find the right location.',
        },
        {
            description_title: 'Any further questions?',
            description: 'You can chat with our hosts through our platform and get a response directly. If you have any issues using our website, or just need some advice on appropriate spaces for you, reach out to us via our WhatsApp line in the "Contact Us" page below.',
        }],
    topCardTitle: 'Seamless Property Discovery Starts Here',
    topCardSection: [
        {
            url: 'https://dminqct125wnz.cloudfront.net/common/production/landing/home/1280_flex_5_b',
            format: 'jpeg',
            title: 'Flexi rental',
            subTitle: '(Commercial)',
            content: 'Need a flexi space by the hour/day? Book here.',
            appType: 'getspaces',
            appKey: 'getspaces',
            route: '/',
            query: {}
        },
        {
            url: 'https://dminqct125wnz.cloudfront.net/common/production/landing/home/1280_office_5_b',
            format: 'jpeg',
            title: 'Fixed rental',
            subTitle: '(Commercial)',
            content: 'Save countless hours and let commercial property find you instead',
            btnLabel: 'Start now',
            appType: 'getproperty',
            appKey: 'getproperty-commercial',
            route: '/',
            query: {
                pass_type: 'monthly'
            }
        }
    ]
};
